var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditCalendar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 15.5001C1.3375 15.5001 0.984375 15.3532 0.690625 15.0595C0.396875 14.7657 0.25 14.4126 0.25 14.0001V3.50012C0.25 3.08762 0.396875 2.7345 0.690625 2.44075C0.984375 2.147 1.3375 2.00012 1.75 2.00012H2.5V0.500122H4V2.00012H10V0.500122H11.5V2.00012H12.25C12.6625 2.00012 13.0156 2.147 13.3094 2.44075C13.6031 2.7345 13.75 3.08762 13.75 3.50012V7.25012H12.25V6.50012H1.75V14.0001H7V15.5001H1.75ZM1.75 5.00012H12.25V3.50012H1.75V5.00012ZM8.5 15.5001V13.1939L12.6437 9.06887C12.7562 8.95637 12.8812 8.87512 13.0187 8.82512C13.1562 8.77512 13.2937 8.75012 13.4312 8.75012C13.5812 8.75012 13.725 8.77825 13.8625 8.8345C14 8.89075 14.125 8.97512 14.2375 9.08762L14.9312 9.78137C15.0312 9.89387 15.1094 10.0189 15.1656 10.1564C15.2219 10.2939 15.25 10.4314 15.25 10.5689C15.25 10.7064 15.225 10.847 15.175 10.9907C15.125 11.1345 15.0437 11.2626 14.9312 11.3751L10.8062 15.5001H8.5ZM9.625 14.3751H10.3375L12.6062 12.0876L12.2687 11.7314L11.9125 11.3939L9.625 13.6626V14.3751ZM12.2687 11.7314L11.9125 11.3939L12.6062 12.0876L12.2687 11.7314Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditCalendar);
export default __webpack_public_path__ + "static/media/edit_calendar.a246657622b1a43ac705f85d0ad60707.svg";
export { ForwardRef as ReactComponent };